import { Mapper } from 'src/base/mapper'
import { ParentOfMasterTypeEntity } from 'src/data/entities/master-type.entity'
import { ParentOfMasterTypeModel } from 'src/domain/models/master-type.model'

export class ParentOfMasterTypeMapper extends Mapper<ParentOfMasterTypeEntity, ParentOfMasterTypeModel> {
	mapFrom(param: ParentOfMasterTypeEntity): ParentOfMasterTypeModel {
		return {
			id: param.id,
			name: param.name,
		}
	}

	mapTo(param: ParentOfMasterTypeModel): ParentOfMasterTypeEntity {
		return {
			parentId: null,
			id: param.id,
			name: param.name,
			value: null,
			description: null,
			seq: null,
		}
	}
}
